import api from "@/services/api";

const { get, post, put, delete: del } = api.getPrefixedMethods("users");

export default {
  listUsers() {
    return get("");
  },
  listTeammates() {
    return get("teammates");
  },
  inviteUser(email) {
    return post("invite", { email });
  },
  revokeInvite(pk) {
    return del(`${pk}`);
  },
  getUserActionNeeded(pk) {
    return get(`${pk}/action-needed`);
  },
  updateUserActionNeeded(pk, scope, statuses) {
    return put(`${pk}/action-needed`, { scope, statuses });
  },
  updateUserActionNeededLock(pk, locked) {
    return put(`${pk}/action-needed`, { locked });
  },
  updateUserAssignedOnly(pk, restricted) {
    return put(`${pk}/assigned-only`, { restricted });
  },
  deleteUser(pk) {
    return del(`${pk}`);
  },
  getGrantableCompanies() {
    return get("grantable-companies");
  },
  getUserCompanies(pk) {
    return get(`${pk}/companies`);
  },
  updateUserCompanies(pk, companyIds) {
    return put(`${pk}/companies`, { companyIds });
  },
};
